import CropListDisplay from './CropListDisplay';
import { useRef, useEffect } from 'react';
import  {useDispatch} from 'react-redux';
import usePresentSelector from './usePresentSelector';

import { FocusedAnnotationContext } from './Contexts';
import G from './Getters';
import A from './ActionCreators';
import { useState, useContext } from 'react';

import SampleLayoutChooserModal from './SampleLayoutChooserModal';


import useLocalReducer from './useLocalReducer';



const WESTERN_BLOT_ORGANIZATION_FEATURE = false;


export default function CropPreviewContainer({
  atns,
  imageId,
  temporaryAnnotationProperties,
  notifyAnnotationPropertyChange,
  imgRef,imageSetId, 
  temporaryAdjustments,
  labelEditable,

  cropListMode,
}){

  let dispatch = useDispatch();

  let { focusedAnnotationId,
        setFocusedAnnotationId,
  } = useContext(FocusedAnnotationContext);


  let [ localState, localDispatch ] = useLocalReducer({
    showQuantificationRegions:true
  })

  const [isChoosingSampleLayout,setIsChoosingSampleLayout] = useState(false);

  let [movingId, setMovingId] = useState();



  let state = usePresentSelector(state => state);

  let westernBlots = usePresentSelector(state => G.getDataItems(state,"westernBlots"));

  let focusedAnnotation = state.data.annotations[focusedAnnotationId];

  
  const [ cropPreviewContainerWidth, setCropPreviewContainerWidth ] = useState();

  let annotationsNotInWesternBlots = WESTERN_BLOT_ORGANIZATION_FEATURE && atns.filter(atn => atn.ls && (!atn.links || !atn.links.find(link => link.type === 'westernBlot')));

  const onSelectAnnotation = atnId => setFocusedAnnotationId(atnId)

  const cropPreviewContainerRef = useRef();
  useEffect(() => {
    if( !cropPreviewContainerWidth && cropPreviewContainerRef.current ){
      setCropPreviewContainerWidth(cropPreviewContainerRef.current.getBoundingClientRect().width);
    }
  })

  return (
    <>

      <div ref={cropPreviewContainerRef} onClick={e => {

        focusedAnnotation && dispatch(A.setAnnotationProperties({
          _id:focusedAnnotation._id, 
          ...temporaryAnnotationProperties, 
        }))

        debugger;

        setFocusedAnnotationId(null);
      }}
        class="sg-col"
        style={{width:'100%',height:'100%',
          overflow:'hidden',
          padding:20}}>
        {false && <div>{"Width: " + cropPreviewContainerWidth}</div>}

        

        <CropListDisplay {...{
          atns,
          temporaryAnnotationProperties,
          imageId,
          cropListMode,

        }}/>

        

        <div class="flex-expand"/>



        

        {false && isChoosingSampleLayout && <SampleLayoutChooserModal {...{closeModal:() => setIsChoosingSampleLayout(false)}}/>}

        

      </div>
      

    </>
  )
}
